<template>
  <section
    v-if="items.length"
    data-qa="analyses_popular_section"
    class="analyses-popular-section d-flex flex-column ga-6"
  >
    <h2
      class="text-h6 text--text mb-0"
    >
      Популярные анализы
    </h2>

    <CoreSwiper
      :slides-per-view="isMobile ? 1.2 : 'auto'"
      :has-navigation="!isMobile"
      :has-pagination="isMobile"
      :space-between="16"
      equal-slides-height
      :class="{ 'analyses-popular-section__slider': !isMobile }"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="item in items"
          :key="item.id"
          v-bind="slideAttrs"
        >
          <AnalysesPopularCard
            :is-mobile="isMobile"
            :name="item.name"
            :href="item.href"
            :price="item.price"
            :old-price="item.oldPrice"
            :duration="item.duration"
            :biomaterial="item.biomaterial"
            class="analyses-popular-section__card"
          />
        </div>
      </template>
    </CoreSwiper>
  </section>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import useContextStore from 'src/store/useContextStore'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import AnalysesPopularCard from 'src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesPopularCard.vue'
import type { PopularAnalysisCard } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'

defineProps<{
  items: PopularAnalysisCard[]
}>()

const { context } = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

provide('isMobile', isMobile.value)
</script>

<style lang="scss" scoped>
.analyses-popular-section {
  &__slider {
    :deep(.swiper-slide) {
      width: 220px;
    }

    :deep(.analyses-popular-card) {
      width: 220px;
      min-height: 175px;
    }
  }

  &__card {
    width: 100%;
    height: 100%;
  }
}
</style>
